const Plus = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 5v6H5v2h6v6h2v-6h6v-2h-6V5h-2Z"
    />
  </svg>
)

export default Plus
